import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  card: {
    width: '24%',
    margin: '10px 1% 0 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '@media (max-width: 1072px)': {
      width: '32%',
    },
    '@media (max-width: 800px)': {
      width: '49%',
    },
    '@media (max-width: 558px)': {
      width: '100%',
    },

    '&:hover': {
      boxShadow:
        '0 10px 15px -3px rgba(0,0,0,.1), 0 4px 6px -2px rgba(0,0,0,.05)',
      background: '#f4fdff'
    },
  },

  heading: {
    fontSize: 17,
    lineHeight: '22px',
    color: '#3d496bd9'
  },

  value: {
    fontSize: 30,
    color: '#000'
  }
});

const CardBox = (props) => {
  const classes = useStyles();
  const { uitf } = props;
  const TW_URL = `https://twitter.com/intent/tweet?&text=${uitf.name.replace(
    / /g,
    '+'
  )}+${
    uitf.value
  }+%23uitf+%23investment+%23mutualfunds+%23ph&url=https%3A%2F%2Fuitf.now.sh`;

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography gutterBottom variant="h6" component="h2" className={classes.heading}>
          {uitf.name}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p" className={classes.value}>
          {uitf.value}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" color="primary" target="_blank" href={TW_URL}>
          SHARE VIA TWITTER
        </Button>
      </CardActions>
    </Card>
  );
};

export default CardBox;
